<template>
    <!-- lg:mb-[5rem] mb-[3rem] -->
    <footer class="bg-[#171717] text-white w-screen">
        <client-only>
            <div
                :class="`flex-col flex lg:flex-row ${(isPlatformsLinksExist || isSocialLinksExist) ? 'justify-between' : 'justify-center'}  items-center gap-3.5 pt-8 py-7 app-container bg-[#1D1D1D] min-h-[--main-footer-height]`">
                <div
                    :class="`flex flex-col lg:items-start ${(isPlatformsLinksExist || isSocialLinksExist) ? 'lg:items-start' : 'lg:items-center'} items-center w-[100%] lg:w-[60%]`">
                    <img src="@/assets/footer/logo.svg" width="256" height="82.2" loading="lazy" :draggable="false" alt="logo-ct" class="w-[10rem] select-none md:w-[14rem] lg:w-[16rem]" />
                    <p class="text-[#FFFFFFD9] mt-6 text-center lg:text-start text-[.8rem] lg:text-[0.9rem] multi-lines-text">
                        {{ isRTL ? layout?.footer?.footer_ar : layout?.footer?.footer_en }}
                    </p>
                </div>
                <!--  Platforms and social media Links  -->
                <div v-if="isPlatformsLinksExist || isSocialLinksExist"
                    :class="`w-[100%] lg:w-[37%] xl:w-[30%] flex flex-col items-center lg:items-start justify-center lg:justify-end`">
                    <p v-if="isPlatformsLinksExist">{{ $t('user.footer.get_the_full_experience') }}</p>
                    <div class="flex flext-wrap justify-center lg:justify-start gap-2 mt-6 w-[100%]">
                        <a v-if="layout?.platforms?.android_link" :href="layout?.platforms?.android_link" title="Download the Cezma app on Android" target="_blank"
                            class="cursor-pointer">
                            <img src="@/assets/footer/google.svg " width="112" height="33.17" alt="logo-ct"
                                class="w-[7rem] lg:w-[7rem] xl:w-[8rem] 2xl:w-[10rem]" />
                        </a>
                        <a v-if="layout?.platforms?.ios_link" :href="layout?.platforms?.ios_link" title="Download the Cezma app on iOS" target="_blank"
                            class="cursor-pointer">
                            <img src="@/assets/footer/apple.svg" width="112" height="33.17" alt="logo-ct"
                                class="w-[7rem] lg:w-[7rem]] xl:w-[8rem] 2xl:w-[10rem]" />
                        </a>
                    </div>
                    <p class="mt-8" v-if="isSocialLinksExist">{{ $t('user.footer.contact_us') }}</p>
                    <div class="flex gap-3 mt-4">
                        <a v-if="formattedLink?.instagram" :href="formattedLink?.instagram" title="Find us on Instagram" target="_blank"
                            class="cursor-pointer rounded-full instagram transition-all duration-300">
                            <img src="@/assets/footer/insta.svg " width="37" height="37" alt="logo-ct" class="object-cover" />
                        </a>
                        <a v-if="formattedLink?.twitter" :href="formattedLink?.twitter" title="Find us on X"  target="_blank"
                            class="cursor-pointer rounded-full twitter transition-all duration-300">
                            <img src="@/assets/footer/twitter.svg" width="37" height="37" alt="logo-ct" class="object-cover" />
                        </a>
                        <a v-if="formattedLink?.whatsapp" :href="formattedLink?.whatsapp" title="Find us on Whatsapp"  target="_blank"
                            class="cursor-pointer rounded-full whatsapp transition-all duration-300">
                            <img src="@/assets/footer/whatsapp.svg" width="37" height="37" alt="logo-ct" class="object-cover" />
                        </a>
                        <a v-if="formattedLink?.facebook" :href="formattedLink?.facebook" title="Find us on Facebook"  target="_blank"
                            class="cursor-pointer rounded-full facebook transition-all duration-300">
                            <img src="@/assets/footer/facebook-circular-logo.svg" width="37" height="37" alt="logo-ct" class="object-cover" />
                        </a>
                        <a v-if="formattedLink?.telegram" :href="formattedLink?.telegram" title="Find us on Telegram"  target="_blank" class="cursor-pointer rounded-full facebook transition-all duration-300 ">
                            <img src="@/assets/footer/telegram.svg" width="37" height="37" alt="logo-ct" class="object-cover w-[37.36px] h-[37.36px]" />
                        </a>
                    </div>
                </div>
            </div>
        </client-only>
        <!-- static pages -->
        <div
            class="flex-col lg:flex lg:flex-row justify-between items-center text-[#8D8D8D] py-3 app-container text-center font-sans text-base font-normal leading-relaxed text-blue-gray-900 antialiased">
            <div class="flex flex-wrap lg:justify-start justify-center w-[100%] lg:w-[60%] gap-4">
                <NuxtLink :to="ROUTESNAMES.user.privacyPolicy" :title="$t('user.footer.privacy_policy')">
                    {{ $t('user.footer.privacy_policy') }}
                </NuxtLink>
                <NuxtLink :to="ROUTESNAMES.user.termsCondition" :title="$t('user.footer.terms_of_use')">{{
                    $t('user.footer.terms_of_use') }}
                </NuxtLink>
                <NuxtLink :to="ROUTESNAMES.user.aboutUs" :title="$t('user.footer.about_us')" >{{ $t('user.footer.about_us') }}
                </NuxtLink>
                <NuxtLink :to="ROUTESNAMES.user.contactUs" :title="$t('user.footer.contact_us')">{{ $t('user.footer.contact_us') }} </NuxtLink>
            </div>
            <p class="mt-4 lg:mt-0 w-[100%] lg:w-[37%] xl:w-[30%] text-[.9rem] text-center lg:text-start">
                {{ $t('user.footer.copyright', {year: currentYear}) }}
            </p>
        </div>
    </footer>
</template>

<script>
import { mapState } from 'pinia';
import { useGlobalStore } from '@/store/Modules/global';
import { generateWhatsappLink, generateTelegramLink, ROUTESNAMES } from "@/helpers";

export default {
    components: {},
    data() {
        return {
            ROUTESNAMES
        };
    },
    computed: {
        ...mapState(useGlobalStore, ['layout']),

        isSocialLinksExist() {
            return this.layout?.social_media?.instagram || this.layout?.social_media?.twitter || this.layout?.social_media?.whatsapp || this.layout?.social_media?.facebook
        },
        isPlatformsLinksExist() {
            return this.layout?.platforms?.android_link || this.layout?.platforms?.ios_link
        },
        URLLink() {
            return window.location.href || "";;
        },
        formattedLink() {
            return {
                instagram:this.layout?.social_media?.instagram,
                twitter:this.layout?.social_media?.twitter,
                whatsapp:generateWhatsappLink({phone_number: this.layout?.social_media?.whatsapp, message: this.$t('general.whatsapp_message'), link: this.URLLink}),
                facebook:this.layout?.social_media?.facebook,
                telegram:generateTelegramLink(this.layout?.social_media?.telegram),
            }
        },
        currentYear(){
            return new Date().getFullYear();
        }
    },
};
</script>

<style scoped>
a:hover {
    color: white;
}

a.router-link-exact-active {
    color: white;
}

@media only screen and (min-width: 640px) {

    .facebook:hover,
    .facebook:focus {
        filter: drop-shadow(rgba(66, 103, 178, 0.7) 0px 0px 9px);
    }

    .twitter:hover,
    .twitter:focus {
        filter: drop-shadow(rgba(0, 172, 237, 0.7) 0px 0px 9px);
    }

    .instagram:hover,
    .instagram:focus {
        filter: drop-shadow(rgba(131, 58, 180, 0.7) 0px 0px 9px);
    }

    .whatsapp:hover,
    .whatsapp:focus {
        filter: drop-shadow(rgba(118, 140, 126, 0.7) 0px 0px 9px);
    }
}
</style>
